<nb-card class="loss-reason-dialog">
  <nb-card-header>
    <h1>{{ 'crm.loss_title' | translate }}</h1>
    <p class="subtext">{{ 'crm.loss_sub' | translate }}</p>
  </nb-card-header>
  <nb-card-body>
    <nb-select fullWidth [placeholder]="'crm.loss_reason' | translate"
               [ngModel]="reason"
               (selectedChange)="onReasonChange($event)">
      <nb-option *ngFor="let r of lossReasons" [value]="r">{{ ('crm.loss.' + r) | translate }}</nb-option>
    </nb-select>
    <label class="note-label">{{ 'crm.loss_note_label' | translate }}</label>
    <textarea nbInput fullWidth rows="3"
              [placeholder]="'crm.loss_note_placeholder' | translate"
              [(ngModel)]="note"></textarea>
  </nb-card-body>
  <nb-card-footer>
    <button nbButton type="button" (click)="cancel()">{{ 'cancel' | translate }}</button>
    <button nbButton type="button" status="danger" [disabled]="!reason" (click)="confirm()">{{ 'confirm' | translate }}</button>
  </nb-card-footer>
</nb-card>
